import { useParams } from "react-router-dom";
import SoftwareInventoryCreateUpdateForm from "./components/SoftwareInventoryCreateUpdateForm";
import SoftwareInventoryFormHeader from "./components/SoftwareInventoryFormHeader";

import { useSoftwareInventoryById } from "@hooks/inventory/softwareInventory/useSoftwareInventoryById";

import {
  SoftwareInventoryResponseType,
  SoftwareInventoryType,
} from "@type/inventory/software-inventory";

export default function SoftwareInventoryForm() {
  const { id } = useParams();

  const { softwareInventoryState, createSoftwareInventory } =
    useSoftwareInventoryById(id ? id : "");

  const { getSingleData, updateSuccess, updateError } =
    softwareInventoryState || ({} as SoftwareInventoryResponseType);
  const { data } = getSingleData || ({} as SoftwareInventoryType);

  return (
    <div className="p-10">
      <SoftwareInventoryFormHeader />
      <SoftwareInventoryCreateUpdateForm
        softwareId={id}
        SoftwareData={id ? data : null}
        updateError={updateError}
        updateSuccess={updateSuccess}
        createSoftwareInventory={createSoftwareInventory}
      />
    </div>
  );
}
